module.exports = __webpack_public_path__ + "img/figure-12.af8643b2.png";